<template>
    <div class="min-h-screen flex flex-col justify-center items-center text-center bg-a-blue-f2f5ff" data-cy="section_under_construction_main">
        <div class="w-full">
            <div>
                <img class="mx-auto" data-cy="img_under_construction" src="@/assets/image/img-no-internet.png" />
            </div>
            <div class="text-14 text-center text-a-gray-a4a4a4 leading-normal pt-2"
                data-cy="text_under_construction_message"
                v-html="lbl.under_construction">
            </div>
        </div>
    </div>
</template>
<script>
//mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';

export default {
    name: 'UnderConstruction',
    mixins: [LocaleMixin],
}
</script>
<style lang="scss" scoped>
</style>
